<template>
  <div>
    <Head :title="`Edit Booking: ${bookings.booking_number}`" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link href="/bookings">Bookings</Link></li>
        <li class="breadcrumb-item active" aria-current="page">Edit Booking {{ bookings.booking_number }}</li>
      </ol>
    </nav>

    <trashed-message v-if="bookings.deleted_at" class="mb-6" @restore="restore">This booking has been deleted.</trashed-message>

    <div class="actions-bar content-box mb-3">
      <ShowLogs v-if="auth.user.role_admin" :logs="logs" />
      <SendMail v-if="(auth.user.role_admin || auth.user.role_main_agent) && mailStatus.includes(form.status)" :bookings="bookings" :form="form" :mail_inserts="mail_inserts" :mail_templates="mail_templates" :mail_pdfs="mail_pdfs" />
      <button type="button" class="btn btn-primary" @click="downloadPdf()">Download PDF</button>
      <MailOperator :bookings="bookings" :form="form" :mail_inserts="mail_inserts" />
      <Quotation :bookings="bookings" :form="form" :mail_inserts="mail_inserts" />
    </div>

    <BookingForm :form="form" :auth="auth" :customers="customers" :types="types" :operators="operators" :airports="airports" :products="products" />

    <form @submit.prevent="update">
      <div class="actions-toolbar d-flex justify-content-between">
        <button v-if="!bookings.deleted_at" class="btn btn-outline-danger" tabindex="-1" type="button" @click="destroy">Delete Booking</button>
          <loading-button :loading="form.processing" class="btn btn-primary" type="submit">Update Booking</loading-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Editor from '@tinymce/tinymce-vue'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import SendMail from './component/Mail/SendMail'
import MailOperator from './component/Mail/MailOperator'
import Quotation from './component/Mail/Quotation'
import BookingForm from './component/BookingForm'
import ShowLogs from '@/components/ShowLogs'

export default {
  components: {
    Head,
    Editor,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TrashedMessage,
    SendMail,
    MailOperator,
    Quotation,
    BookingForm,
    ShowLogs
  },
  layout: Layout,
  props: {
    bookings: Object,
    customers: Object,
    flights: Object,
    airports: Object,
    operators: Object,
    types: Object,
    products: Object,
    mail_templates: Object,
    mail_inserts: Object,
    mail_pdfs: Object,
    order_lines: Object,
    logs: Object
  },
  remember: 'form',
  data() {
    return {
      mailStatus: ['offer', 'reservation', 'booked'],
      form: this.$inertia.form({
        id: this.bookings.id,
        agencies_id: this.bookings.agencies_id,
        status: this.bookings.status,
        customers_id: this.bookings.customers_id,
        itinerary: this.bookings.itinerary,
        show_itinerary: this.bookings.show_itinerary,
        journeys: this.bookings.journeys,
        passengers: this.bookings.passengers,
        order_lines: this.bookings.order_lines,
        comment: this.bookings.comment,
        show_comment: this.bookings.show_comment,
        intern_comment: this.bookings.intern_comment,
        subtotal: this.bookings.subtotal,
        taxes: this.bookings.taxes,
        final_total: this.bookings.final_total,
        payment_url: this.bookings.payment_url
      })
    }
  },
  computed: {
    auth() {
      return this.$page.props.auth
    }
  },
  methods: {
    update() {
      this.form.put(`/bookings/${this.bookings.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this booking?')) {
        this.$inertia.delete(`/bookings/${this.bookings.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this booking?')) {
        this.$inertia.put(`/bookings/${this.bookings.id}/restore`)
      }
    },
    downloadPdf() {
      //this.$inertia.get(`/generate-pdf/${this.bookings.id}`)
      window.open(`/generate-pdf/${this.bookings.id}`, '_blank', 'noreferrer');
    },
  },
}
</script>
